import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AutocompleteOption } from '@app/forms/formly/types/input-field-with-autocomplete/input-field-with-autocomplete.component';

@Component({
  selector: 'input-field-with-autocomplete-option',
  templateUrl: './input-field-with-autocomplete-option.component.html',
  styleUrls: ['./input-field-with-autocomplete-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFieldWithAutocompleteOptionComponent {
  @Input() option: AutocompleteOption;
}
